import React, { useEffect, useState } from "react";
import { CheckDateOfBirthInput, todayDate } from "../../../utils/DataTime";
import DatePicker from "react-datepicker"; // Add this import statement
import { format, parse } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { CustomDateInput } from "./DateInput";
import { log } from "console";
import { parseISO } from "date-fns";
import { readFromLocalStorage } from "../../../utils/DataEncryption";

interface InputProps {
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>,payloadName:any,key:any) => void;
  placeholder?: string;
  type: string; // Specify type as "text" or "number"
  value?: string | number;
  name?: string;
  autoComplete?: string;
  maxLength?: number;
  disabled?: boolean;
  allowSplChar?: boolean;
  allowNumber?: boolean;
  regexCode?: any;
  label?: string;
  max?: any;
  min?: any;
  borderColor?: string;
  onKeyDown?: any;
  isDateOfBirth?: boolean;
  setShowErrorMessage?:  (value: boolean) => void;
  payloadName?: string;
  key?: string;
  isRequired?: boolean;
  bankDetailsManditory?: boolean;
  editMode?: any; // Assuming editMode is a prop to determine if the field is editable
  order?: any; // Assuming order is a prop to determine if the field is mandatory
  // isBankDetailsManditoryInEditFlow?:any;
  valueForOnboarding?:any;
  isBankDetailsManditoryInEditFlow?:any;
  indexOfEducationalDetails?:any;
  indexOfWorkDetails?:any;
  isWorkEditButtonClicked?:any;
  isEducationalEditButtonClicked?:any;
  isPreviousButtonClicked?:any;
}

const Input: React.FC<InputProps> = ({
  handleOnChange,
  value,
  placeholder,
  type,
  name,
  autoComplete,
  disabled,
  maxLength,
  regexCode,
  label,
  max,
  borderColor,
  min,
  onKeyDown,
  isDateOfBirth,
  payloadName,
  key,
  isRequired,
  bankDetailsManditory,
  order,
  editMode,
  valueForOnboarding,
  indexOfEducationalDetails,
  setShowErrorMessage= () => {}, 
  isBankDetailsManditoryInEditFlow,
  indexOfWorkDetails,
  isWorkEditButtonClicked,
  isEducationalEditButtonClicked,
  isPreviousButtonClicked,
}: InputProps) => {
  // useEffect(() => {
  // console.log("valueForOnboarding",valueForOnboarding)
  // },[valueForOnboarding]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowErrorMessage(false);
    let inputValue = e.target.value;

    if (regexCode) {
      if (regexCode.test(inputValue)) {
        handleOnChange(e,payloadName,key);
      }
    } else {
      if (isDateOfBirth) {
        const isDobValid = CheckDateOfBirthInput(e.target.value);
        if (isDobValid) {
          handleOnChange(e,payloadName,key);
        } else {
          setShowErrorMessage(true);
        }
      } else {
        handleOnChange(e,payloadName,key);
      }
    }
  };
const toDate = (v: string | number | undefined): Date | null => {
  if (!v) return null;

  if (typeof v === "string") {
    try { 
      return parseISO(v); 
    } catch {
      return null;
    }
  }

  return new Date(v); // If it's a timestamp (number)
};
const [selectedDate, setSelectedDate] = useState<Date | null>(
  type === "date" ? toDate(value) : null
);
const handleDateChange = (date: Date | null) => {
  if (!date) return;
  setSelectedDate(date);

  const formattedDisplay = format(date, "MM/dd/yyyy");
  const formattedPayload = format(date, "yyyy-MM-dd");

  // Optional DOB validation
  if (isDateOfBirth && !CheckDateOfBirthInput(formattedDisplay)) {
    setShowErrorMessage(true);
    return;
  }

  const fakeEvent = {
    target: { value: formattedPayload, name },
  } as unknown as React.ChangeEvent<HTMLInputElement>;

  handleOnChange(fakeEvent, payloadName, key);
};

// Convert min/max (string → Date) for DatePicker if provided
const minDate = type === "date" && min ? toDate(min) : undefined;
const maxDate = type === "date" && max ? toDate(max) : undefined;


const getValueFromSubsegment = (
    onboardingData: any[],
    index: number,
    fieldName: any,
  ): string => {
    if (!Array.isArray(onboardingData)) return "";
    // Filter the appropriate segment based on which edit button is clicked
    let filteredData = onboardingData;
    // if (isEducationalEditButtonClicked) {
    //   filteredData = onboardingData?.filter(
    //     (segment: any) => segment?.name === "Educational Information"
    //   );
    // } else if (isWorkEditButtonClicked) {
    //   filteredData = onboardingData?.filter(
    //     (segment: any) => segment?.name === "Work Experience"
    //   );
    // }
    // Case 1: Nested structure
    if (
      filteredData[index] &&
      Array.isArray(filteredData[index].attributes)
    ) {
      const attr = filteredData[index].attributes.find(
        (item: { name: string }) => {
          
          return item?.name === fieldName}
      );
      return attr?.value || "";
    }
  
    // Case 2: Flat structure
    const attr = filteredData.find(
      (item: { name: string }) => item.name === fieldName
    );
    return attr?.value || "";
  };


const getValueFromStore = (reduxData: any[], fieldName: any): string => {
  if(fieldName === "country"){
    return readFromLocalStorage("country") ;
  }
  if (!Array.isArray(reduxData)) return "";

  const attr = reduxData.find((item) => item.name === fieldName);
  return attr?.value || "";
};

const minEighteenYearsToWork = () => {
  const today = new Date(todayDate); // assuming todayDate is a valid date string or Date
  return new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
};


  return (
    type === "date" ? (
      <div
      className={`relative mt-5 border ${
        borderColor || "border-sideMenuHelpBox"
      } rounded-xl focus-within:border-blue-500`}
    >
      {label && (
        <label
          className={`absolute top-0 left-2 bg-white px-2 labelText ${
            borderColor === "border-redColor" && "text-redColor"
          }`}
        >
          <div className="flex">
            {label}
            {isRequired && (
              <div className="text-redColor quickLinksTitle pl-1">*</div>
            )}
          </div>
        </label>
      )}
  
  <DatePicker
        selected={editMode ? toDate(value) : valueForOnboarding ? toDate(getValueFromStore(valueForOnboarding, payloadName)) : selectedDate }
        onChange={handleDateChange}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder || "Select a date"}
        disabled={disabled}
        customInput={<CustomDateInput />}
        maxDate={payloadName === "dateOfBirth" ? minEighteenYearsToWork() : max}
        showYearDropdown
        showMonthDropdown
        dropdownMode="select"// Ensure todayDate is converted to Date
      />
      </div>
    ) : (
      /* ---------- original text / number input ---------- */
      <div
        className={`relative mt-5 border ${
          borderColor || "border-sideMenuHelpBox"
        } rounded-xl focus-within:border-blue-500`}
      >
        {label && (
          <label
            className={`absolute top-0 left-2 bg-white px-2 labelText ${
              borderColor === "border-redColor" && "text-redColor"
            }`}
          >
            <div className="flex">
              {label}
              {isRequired &&(
                <div className="text-redColor quickLinksTitle pl-1">*</div>
              )}
              {
             ((bankDetailsManditory && order === 3 && payloadName!=="panNumber") || (isBankDetailsManditoryInEditFlow && order === 3 && payloadName!=="panNumber")) && <div className="text-redColor quickLinksTitle pl-1">*</div>
              }
            </div>
          </label>
        )}
  
        <input
          onChange={handleChange}
          type={type === "number" ? "text" : type}
          name={name}
          className={`w-full p-4 ${
            value && value.toString().length ? "text-inputTextColor" : "text-sideMenuHelpBox"
          } border border-transparent rounded-2xl focus:outline-none`}
          placeholder={placeholder}
          // value={value}
          value={
            value ||
            (order === 0 || order ===3 && isPreviousButtonClicked
              ? getValueFromStore(valueForOnboarding, payloadName)
              : 
              (order === 1 || order === 2) && isEducationalEditButtonClicked
              ? getValueFromSubsegment(valueForOnboarding, indexOfEducationalDetails, payloadName)
              : (order === 1 || order === 2) && isWorkEditButtonClicked
              ? getValueFromSubsegment(valueForOnboarding, indexOfWorkDetails, payloadName)
              :
              value)
          } 
          
          autoComplete={autoComplete}
          required
          maxLength={
            payloadName === "primaryPhoneNumber" || payloadName === "linkedMobileNumber"
              ? 10
              : payloadName === "yearOfPassing"
              ? 4
              : payloadName === "percentage"
              ? 3
              : maxLength
          }
          disabled={editMode && payloadName === "country" ? true : disabled}
          max={max}
          min={min}
          onKeyDown={onKeyDown}
          style={{ color: "black" }}
        />
      </div>
    )
  ); // Fixed return statement
};

export default Input;
